import InstallmentsLearnMore from './InstallmentsLearnMore';

export default InstallmentsLearnMore;
